module.exports = "function hello() {\n  print(src: 'Hello World')\n}"